import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { ScrollIndicator } from '../shared/ScrollIndicator';
import { useDeviceType } from '../../hooks/useDeviceType';
import { BackgroundLayer } from './BackgroundLayer';

export function HeroBanner() {
  const { isMobile } = useDeviceType();

  const scrollToNext = () => {
    const nextSection = document.querySelector('#products');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <BackgroundLayer
        videoSrc={isMobile ? '/videos/zwheel-mobile-hero.mp4' : 'https://www.youtube.com/watch?v=zApGZ1rQzyM'}
        fallbackImageSrc="/images/hero-background.jpg"
        posterImageSrc="/images/hero-poster.jpg"
        isMobile={isMobile}
      />

      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(0,0,0,0.82)_0%,rgba(0,0,0,0.56)_42%,rgba(0,0,0,0.24)_100%)] z-10" />

      <div className="home-shell min-h-screen flex items-center py-28">
        <div className="relative z-20 max-w-3xl">
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-3xl text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-[0.95] mb-5 drop-shadow-[0_16px_44px_rgba(0,0,0,0.44)]"
          >
            Patinetes electricos con caracter real
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.32 }}
            className="max-w-xl text-lg md:text-2xl text-white leading-relaxed mb-8 drop-shadow-[0_10px_30px_rgba(0,0,0,0.52)]"
          >
            Descubre la gama Zwheel y encuentra el modelo que mejor encaja con tu forma de moverte.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.42 }}
            className="flex flex-col sm:flex-row gap-3"
          >
            <Link
              to="/patinetes-electricos"
              className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-black transition-all duration-300 hover:bg-[#f2eadb]"
            >
              Explorar patinetes
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>

            <Link
              to="/accesorios-recambios"
              className="inline-flex items-center justify-center rounded-full border border-white/30 bg-black/24 px-6 py-3.5 text-sm font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-black/36"
            >
              Accesorios y recambios
            </Link>
          </motion.div>
        </div>
      </div>

      <ScrollIndicator
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-30"
        onClick={scrollToNext}
        delay={0.9}
      />
    </section>
  );
}
